import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { api1 } from "../../utils/axiosInstance";
import Sidebar from "../../components/Sidebar";

const ViewUserProfile = () => {
  const { id } = useParams();


  const fetchProfileData = async () => {
    const response = await api1.get(`/api/user/get-single-profile/${id}`);
    return response.data || {}; 
  };

  const {
    data: profileData,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["singleProfile", id], 
    queryFn: fetchProfileData, 
    enabled: !!id, 
  });





  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <Sidebar>
      <div className="rounded-md px-6 py-5 shadow bg-white">
        <p className="font-bold text-2xl">User Profile</p>
        <p className="font-normal text-base">
          View user profile information
        </p>
        <hr className="min-w-full border border-border-color -mx-6 my-5" />
        <div className="font-bold text-lg mb-4">Personal Information</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.firstName || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.lastName || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Gender</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.gender || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Country</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.country || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">State / Province</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.stateOrProvince || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">City</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.city || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Age Group</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.age || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Race</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.race || "N/A"}
            </div>
          </div>
        </div>
        <hr className="border border-border-color my-12" />
        <div className="font-bold text-lg">Documents Uploads</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Profile Photo</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.profilePhoto ? (
                <img 
                  src={profileData.profilePhoto} 
                  alt="Profile" 
                  className="w-20 h-20 rounded-full object-cover"
                />
              ) : (
                "No photo uploaded"
              )}
            </div>
          </div>
        </div>
        <hr className="border border-border-color my-12" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Highest Education Level</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.highestLevelEducation || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Employment Status</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.employmentStatus || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Professional Experience</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.professionalExperience || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Years of Work Experience</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.yearsOfExperience || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Current Job / Experience</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.currentJob || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Industry</label>
            <div className="p-3 border border-gray-300 rounded-md bg-gray-50">
              {profileData?.industry || "N/A"}
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  );
};
export default ViewUserProfile;
